import * as moment from 'moment';
import { roundUp } from './utils.common';
import { sweetAlert } from 'src/app/utils/swal';
export const NUMBER_OF_RECORDS = 50;
const MAX_FILE_SIZE_BYTES = 1 * 1024 * 1024; // 1MB
const maxFileSize = 1
export function formatDuration(durationValue:any) {
    // Convert the duration into a moment duration object
    let duration = moment.duration(durationValue, 'seconds');
    // Extract hours and minutes from the duration
    let hours = Math.floor(duration.asHours());  // Get the integer value of hours
    let minutes = duration.minutes();  // Get the remaining minutes
    // Return the result based on the hours
    if (hours > 0) {
      return `${hours} hr ${minutes} mins`;
    } else {
      return `${minutes} mins`;
    }
}
  
export function formatDistance(distance:any) {
  return `${ roundUp(Number((distance / 1609.344).toFixed(2))) } mi`;
}


export function exportToCsv(filename: any, rows: any) {
  var processRow = function (row: any) {
    var finalVal = '';
    for (var j = 0; j < row.length; j++) {
      var innerValue = row[j] === null || row[j] === undefined || row[j] === "" ? 'n/a' : row[j].toString();
      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      };
      var result = innerValue.replace(/"/g, '""');
      if (result.search(/("|,|\n)/g) >= 0)
        result = '"' + result + '"';
      if (j > 0)
        finalVal += ',';
      finalVal += result;
    }
    return finalVal + '\n';
  };

  var csvFile = '';
  for (var i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });

  var link = document.createElement("a");
  if (link.download !== undefined) { // feature detection
    // Browsers that support HTML5 download attribute
    var url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

  }
}

export function validateFileSize(file?: File | null): boolean {
  if (!file) return true;

  if (file.size > MAX_FILE_SIZE_BYTES) {
    sweetAlert(
      'File too large',
      `Maximum file size allowed is ${maxFileSize} MB.`,
      'warning',
      'OK'
    );
    return false;
  }

  return true;
}